import React from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";

export const AttritionRateCallouts = () => {
  const attritionRate = useSelector((state) => state.studioInfo.attritionRate.data);

  return (
    <div className="callout-wrapper">
      {attritionRate.map((elem) => (
        <div
          key={elem.title}
          className="callout"
          data-tooltip-html={elem.tooltip}
          data-tooltip-id={elem.title}
        >
          <p>{elem.title}</p>
          <p className="callout-value">{(elem.current * 100).toFixed(2)}%</p>
          <Tooltip id={elem.title} float />
        </div>
      ))}
    </div>
  );
};
